import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

import {
  Frame,
  Content,
  ImgWrapper,
  Eyebrow,
  Heading,
  Subhead,
} from "../styles/Card.styled"
const Card = ({ component, idx }) => (
  <Frame idx={idx}>
    <ImgWrapper>
      <GatsbyImage
        image={component?.image?.gatsbyImageData}
        alt={component?.image?.alt}
      />
    </ImgWrapper>
    <Content>
      {component?.eyebrow && (
        <Eyebrow eyebrowColor={component?.eyebrowColor}>
          {component?.eyebrow}
        </Eyebrow>
      )}
      {component?.heading && <Heading>{component?.heading}</Heading>}
      {component?.subhead && (
        <Subhead dangerouslySetInnerHTML={{ __html: component?.subhead }} />
      )}
    </Content>
  </Frame>
)

export default Card
